var React = require('react');

function IconAddGroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M739.3 461c62.2 0 112.1-50.2 112.1-112.5S801.5 236 739.3 236c-10 0-19.7 1.3-28.7 3.6-2.7.7-3.8 3.8-2.3 6.1 19.5 29.5 30.6 64.5 30.6 102.7s-11.5 73-30.8 102.8c-1.5 2.3-.3 5.3 2.3 6 9.1 2.5 18.9 3.8 28.9 3.8zm-228.1 24.3c115.4 0 198.1-132.3 107.9-254-.2-.3-.5-.6-.9-.9-121.6-90.8-253.8-7.1-253.8 108.2.1 81.3 65.7 146.7 146.8 146.7zM795 577c31.1 27.4 51.7 62.2 51.7 106.5v71c0 2.2 1.8 4 4 4h104.5c2.2 0 4-1.8 4-4v-71c0-57.8-88.8-93.4-164.2-106.5zm-283.8 9.1c-97.8 0-293.4 48.9-293.4 146.7v93.8c0 2.2 1.8 4 4 4h578.8c2.2 0 4-1.8 4-4v-93.8c0-97.8-195.6-146.7-293.4-146.7zM203.5 485.6V403c0-2.2-1.8-4-4-4h-43.6c-2.2 0-4 1.8-4 4v82.5H68c-2.2 0-4 1.8-4 4v43.6c0 2.2 1.8 4 4 4h83.9v85.2c0 2.2 1.8 4 4 4h43.6c2.2 0 4-1.8 4-4v-85.2h83.9c2.2 0 4-1.8 4-4v-43.6c0-2.2-1.8-4-4-4l-83.9.1z"}));
}

IconAddGroup.displayName = "IconAddGroup";

IconAddGroup.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAddGroup;

IconAddGroup.default = IconAddGroup;
